export default __webpack_public_path__ + "static/media/adobeae.517fe42d.svg";